var MpMailchimpSubscription = {
    created: function () {},

    data: function() {
        return {
            FORM_URL: 'https://mundopetroleo.us12.list-manage.com/subscribe/post-json?&u=f760987f51ffd7d4bc0d46264&id=1f1a07a14d',

            LIST_ID: 'f760987f51ffd7d4bc0d46264&id=1f1a07a14d',
            SEED: 'b_f760987f51ffd7d4bc0d46264_1f1a07a14d',

            LABEL_LEGAL_INFO_SHOW: 'Ver información Legal',
            LABEL_LEGAL_INFO_HIDE: 'Ocultar información Legal',

            COOKIE_SUBSCRIBED_LIFETIME: 365,
            COOKIE_DECLINED_LIFETIME: 15,

            email: '',
            privacity: true,

            errorMessage: '',
            successMessage: '',

            validated: false,
            isSendActive: true,
        };
    },

    computed: {

        emailCheck: function() {
            return !this.validated || FormValidator.isValidEmail(this.email);
        },

        privacityCheck: function() {
            return (!this.validated || this.privacity);
        },

        data: function() {
            return Serializer.serialize({
                'b_f760987f51ffd7d4bc0d46264_1f1a07a14d': '',
                'EMAIL': this.email,
            });
        }
    },

    methods: {

        cleanMessages: function() {
            this.errorMessage = '';
            this.successMessage = '';
        },

        onCookieNewsletterSaved: function() {
            console.warn('🛜 onCookieNewsletterSaved method should be implemented by classes using this mixin');
        },

        saveCookieNewsLetter: function(accepted) {
            CookieManager.setCookie('mp_cookie_newsletter_subcribed', accepted, (accepted) ? this.COOKIE_SUBSCRIBED_LIFETIME : this.COOKIE_DECLINED_LIFETIME);
            this.onCookieNewsletterSaved();
        },

        validateForm: function() {
            var isValid = true;

            this.cleanMessages();
            this.validated = true;

            if (!this.emailCheck) {
                isValid = false;
                this.errorMessage = 'Email no válido.';
            }

            if (!this.privacityCheck) {
                isValid = false;
                this.errorMessage = 'Ha de aceptar la política de privacidad.';
            }

            return isValid;
        },

        onSubscription: function(response) {
            if (response.result === 'success') {
                this.successMessage = response.msg;
                this.$refs.mcform.reset();
                this.saveCookieNewsLetter(true);
            } else {
                this.errorMessage = response.msg;
            }

            this.isSendActive = true;

            return true;
        },

        doSubscription: function() {
            var _this = this;

            if (this.isSendActive && this.validateForm()) {
                this.isSendActive = false;

                return jsonp(this.FORM_URL + '&' + this.data, {
                    param: 'c',
                }, function(err, data) {
                    if (err) {
                        console.log(err.msg);
                    } else {
                        _this.onSubscription(data);
                    }
                });
            }
        },

    }
};
